import { useEffect, useState } from 'react';
import AuthService from 'services/AuthService';
import { UserModel } from 'services/EpdClient';

const userChangedEmitter = createEventEmitter<UserModel>();

export default function useCurrentUser() {
  const [user, setUser] = useState(getUser);

  useEffect(() => {
    const unsubscribe = userChangedEmitter.addListener((newUser) => setUser(newUser));
    return () => unsubscribe();
  }, []);

  return user;
}

export function invalidateCurrentUser() {
  userChangedEmitter.emitEvent(getUser());
}

function getUser() {
  const user = AuthService.getUser();
  if (user) {
    return user;
  }
  throw new Error('Not authenticated');
}

function createEventEmitter<TData>() {
  const listeners: ((data: TData) => void)[] = [];

  return {
    addListener(handler: (data: TData) => void) {
      listeners.push(handler);
      return () => {
        const handlerIndex = listeners.indexOf(handler);
        if (handlerIndex !== -1) {
          listeners.splice(handlerIndex, 1);
        }
      };
    },
    emitEvent(data: TData) {
      listeners.forEach((handler) => handler(data));
    },
  };
}
